import { styled, Typography } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from 'features/app/hooks';
import { teamingAnotherUserNameSelector } from 'features/teaming/teaming-base/store';
import theme from 'features/theme/theme';

export const TeamNameContainer: FC = () => {
  const name = useAppSelector(teamingAnotherUserNameSelector);
  const { t } = useTranslation();
  const teamNameLabel = t('teamUserLabel');

  return (
    <Container data-testid='team-user-block'>
      <Label>{teamNameLabel}</Label>
      <Title>{name}</Title>
    </Container>
  );
};

const Container = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: ${theme.spacing(10, 10)};
  background-color: ${theme.palette.grey[900]};
  border-radius: 8px;
`;

const Title = styled(Typography)`
  color: ${theme.palette.common.white};

  font-family: Inter;
  font-size: 19px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

const Label = styled(Typography)`
  color: ${theme.palette.grey[300]};
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
`;
